var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4688 85.625H37.0312C33.1479 85.625 30 88.7729 30 92.6562V162.969C30 166.852 33.1479 170 37.0312 170H60.4688C64.3521 170 67.5 166.852 67.5 162.969V92.6562C67.5 88.7729 64.3521 85.625 60.4688 85.625ZM48.75 158.281C44.8667 158.281 41.7188 155.133 41.7188 151.25C41.7188 147.367 44.8667 144.219 48.75 144.219C52.6333 144.219 55.7812 147.367 55.7812 151.25C55.7812 155.133 52.6333 158.281 48.75 158.281ZM142.5 43.8629C142.5 56.2895 134.892 63.2598 132.751 71.5625H162.553C172.337 71.5625 179.954 79.6912 180 88.5834C180.024 93.8387 177.789 99.4962 174.305 102.997L174.272 103.029C177.154 109.866 176.686 119.446 171.546 126.311C174.089 133.897 171.525 143.216 166.746 148.212C168.005 153.368 167.404 157.756 164.945 161.288C158.965 169.879 144.145 170 131.613 170L130.779 170C116.633 169.995 105.055 164.844 95.7522 160.705C91.0772 158.625 84.9647 156.051 80.3271 155.966C78.411 155.93 76.875 154.367 76.875 152.451V89.8227C76.875 88.8852 77.2506 87.9855 77.9174 87.3263C89.523 75.8583 94.5135 63.7168 104.026 54.1883C108.363 49.843 109.94 43.2793 111.465 36.9318C112.768 31.5116 115.493 20 121.406 20C128.438 20 142.5 22.3438 142.5 43.8629Z",
    fill: "#5605AA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMonitor);
export default __webpack_public_path__ + "static/media/empty-monitor.1667d5d8.svg";
export { ForwardRef as ReactComponent };